import React from 'react';

const SportHero = ({ sportName, coverImage, tagline }) => {
  return (
    <section className="ub-sport-hero">
      <div className="ub-sport-hero-image-container">
        <img src={coverImage} alt={`${sportName} cover`} className="ub-sport-hero-image" />
        <div className="ub-sport-hero-overlay">
          <div className="ub-sport-hero-content">
            <h1 className="ub-sport-hero-title">{sportName}</h1>
            {tagline && <p className="ub-sport-hero-tagline">{tagline}</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SportHero;
